import { Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const AutoStaffButton = styled(Button)(({ theme, variant = 'dark', fullWidth = false }) => ({
  display: 'flex',
  padding: '14px 20px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '4px',
  alignSelf: 'stretch',
  textWrap: 'nowrap',
  width: fullWidth ? '100%' : 'fit-content',
  transition: 'all 0.3s ease-in-out',
  '&:hover': {
    background: theme.palette.background.hover,
    transform: 'translateY(-1px)',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  },
  '&:active': {
    transform: 'translateY(0)',
  },
  '&.Mui-disabled': {
    opacity: 0.5,
    cursor: 'not-allowed',
    transform: 'none',
    boxShadow: 'none',
    background: theme.palette.background.default,
  },

  ...(variant === 'dark' && {
    background: theme.palette.background.default,
    '&:hover': {
      background: theme.palette.background.hover,
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    },
  }),

  ...(variant === 'light' && {
    backgroundColor: theme.palette.grey[900],
    '&:hover': {
      backgroundColor: theme.palette.grey[800],
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    },
  }),
}));

export const StyledTypography = styled(Typography)(() => ({
  background: 'linear-gradient(90deg, #FF7998 0.29%, #C73B86 32.16%, #871D75 57.6%, #C73B86 74.27%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  transition: 'all 0.3s ease-in-out',
  '&:hover': {
    opacity: 0.9,
  },
}));
